export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Final2_09.15a3e2d3.jpg";